export enum MatchUpDataSection {
  LocationData = 'LocationData',
  InfoPopup = 'InfoPopup'
}
